import React from "react";
import { Typography } from "@mui/material";
import { LoaderContent, LoaderWrapper } from "./Loader.style";
import { useTranslation } from "react-i18next";
import spinner from "../../assets/images/spinner.svg";

function Loader({ showText = true }) {
  const { t } = useTranslation();
  return (
    <LoaderWrapper>
      <LoaderContent>
        <img src={spinner} alt="loading" />
        {showText && (
          <Typography component="h1" variant="h1">
            {t("Loader.text")}
          </Typography>
        )}
      </LoaderContent>
    </LoaderWrapper>
  );
}

export default Loader;
